export enum Action {
    WOB = '10',
    Impersonate = '20'
}
